<template>
  <v-container fluid>
    <!-- Заголовок и кнопки действий -->
    <v-card class="px-4 py-2">

      <h1 class="mb-4 text-h6 text-md-h5 font-weight-bold">
        {{ law ? (i18n().locale === 'ru' ? law.titleRu : law.titleKg) : '' }}
      </h1>

      <div class="d-flex align-center">
        <v-icon small class="mr-2">mdi-calendar-blank-outline</v-icon>
        <span class="caption text-md-body-2">
      {{ law ? formatFullDate(law.publishDate) : '' }}
    </span>
      </div>
    </v-card>

    <!-- Основная таблица с данными -->
    <v-card class="mt-4" v-if="law">
      <v-simple-table >
        <template v-slot:default>
          <tbody>
          <tr>
            <td class="">Номер</td>
            <td class="font-weight-medium">{{ law.registrationNumber }}</td>
          </tr>
          <tr>
            <td>Дата публикации</td>
            <td>
              <v-icon small class="mr-1 mt-n1">mdi-calendar-blank-outline</v-icon>
              {{ formatFullDate(law.publishDate) }}
            </td>
          </tr>
          <tr>
            <td>Инициаторы</td>
            <td>
              <div class="d-flex flex-wrap gap-2">
                <v-chip
                  v-for="deputy in law.deputies"
                  :key="deputy.id"
                  small
                  label
                >
                  {{ deputy.lastName }} {{ deputy.firstName }} {{ deputy.surname }}
                </v-chip>
              </div>
            </td>
          </tr>
          <tr>
            <td>Документы</td>
            <td></td>
          </tr>
          <!-- Секция с HTML описанием и ссылками на документы -->
          <tr>
            <td colspan="2" class="pa-6">
              <div v-html="processedDescription"></div>
            </td>
          </tr>
          </tbody>
        </template>
      </v-simple-table>
      <div class="py-4 px-4">Источник данных: <a target="_blank" :href="`https://kenesh.kg/bills/public/${this.id}`">сайт Жогорку Кенеша Кыргызской Республики</a></div>
    </v-card>

    <!-- Индикатор загрузки -->
    <v-overlay :value="loading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-container>
</template>

<script>
import axios from 'axios';
import i18n from './../plugins/i18n';

export default {
  props: ['id'],
  data: () => ({
    law: null,
    loading: false
  }),
  computed: {
    processedDescription() {
      if (!this.law || !this.law.descriptionRu) return '';
      let desc = i18n.locale === 'ru' ? this.law.descriptionRu : this.law.descriptionKg
      return desc.replace(
        /href="\/uploads/g,
        'target="_blank" href="https://kenesh.kg/uploads'
      );
    }
  },
  created() {
    this.fetchLawDetail();
  },
  methods: {
    i18n() {
      return i18n
    },
    async fetchLawDetail() {
      this.loading = true;
      try {
        const response = await axios.get(`${i18n.locale}/api/jk-laws/${this.id}`);
        this.law = response.data;
      } catch (error) {
        console.error("Error loading law:", error);
      } finally {
        this.loading = false;
      }
    },
    formatFullDate(dateStr) {
      if (!dateStr) return '';
      const date = new Date(dateStr);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      return `${day}-${month}-${year} ${hours}:${minutes}`;
    }
  }
};
</script>
